/* Anavadhya — product page: gallery, in-skirt add-on, gift wrap, add to cart, pinned mobile bar,
   and the "six metres, laid out" strip that unrolls as it scrolls into view. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = root.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);

  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }

  /* Height of the theme's pinned header, shared with CSS as --anv-header-offset. */
  function headerOffset() {
    var header = document.querySelector('.header-section');
    if (!header) return 0;
    var cs = window.getComputedStyle(header);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    return Math.max(0, Math.round(header.offsetHeight + (parseFloat(cs.top) || 0)));
  }
  function setHeaderOffset() { root.style.setProperty('--anv-header-offset', headerOffset() + 'px'); }

  /* ---------- Gallery ---------- */
  function setupGallery(gallery) {
    if (gallery.__anv) return;
    gallery.__anv = true;
    var track = gallery.querySelector('.anv-pd__track');
    var slides = gallery.querySelectorAll('.anv-pd__slide');
    var thumbs = gallery.querySelectorAll('.anv-pd__thumb');
    var dots = gallery.querySelectorAll('.anv-pd__dots span');
    var count = gallery.querySelector('.anv-pd__count');
    var zoom = gallery.querySelector('.anv-pd__zoom');
    if (!track || !slides.length) return;

    function mark(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      if (zoom) {
        var full = slides[index].getAttribute('data-full');
        if (full) { zoom.href = full; zoom.hidden = false; } else { zoom.hidden = true; }
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        mark(i);
      });
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        mark(clamp(i, 0, slides.length - 1));
      });
    }, { passive: true });

    mark(0);
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency || 'INR', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
    }
  }

  /* ---------- Buy box ---------- */
  function setupBuyBox(section) {
    if (section.__anvBuy) return;
    section.__anvBuy = true;
    var form = section.querySelector('form[data-anv-product-form]');
    if (!form) return;
    var currency = section.getAttribute('data-currency') || 'INR';
    var basePrice = parseInt(section.getAttribute('data-price'), 10) || 0;
    var submit = form.querySelector('[data-anv-submit]');
    var submitLabel = submit ? submit.getAttribute('data-label') : '';
    var errorBox = section.querySelector('[data-anv-error]');
    var bar = section.querySelector('.anv-pd__bar');
    var barPrice = section.querySelector('[data-anv-bar-price]');
    var barNote = section.querySelector('[data-anv-bar-note]');
    var variantSelect = form.querySelector('select[name="id"]');
    var gift = form.querySelector('[data-anv-gift]');
    var giftToggle = gift ? gift.querySelector('[data-anv-gift-toggle]') : null;
    var giftMsgWrap = gift ? gift.querySelector('[data-anv-gift-msg]') : null;
    var giftMsg = gift ? gift.querySelector('[data-anv-gift-message]') : null;
    var giftCount = gift ? gift.querySelector('[data-anv-gift-count]') : null;

    function selectedGift() {
      if (!giftToggle || !giftToggle.checked) return null;
      var id = gift.getAttribute('data-gift-id');
      return {
        id: id ? parseInt(id, 10) : null,
        price: parseInt(gift.getAttribute('data-gift-price'), 10) || 0,
        title: gift.getAttribute('data-gift-title') || 'Gift wrap',
        message: giftMsg ? giftMsg.value.trim() : ''
      };
    }

    function syncGift() {
      if (giftMsgWrap) giftMsgWrap.hidden = !(giftToggle && giftToggle.checked);
      if (giftMsg) giftMsg.disabled = !(giftToggle && giftToggle.checked);
      if (giftCount && giftMsg) giftCount.textContent = giftMsg.value.length + ' / ' + (giftMsg.getAttribute('maxlength') || '');
    }

    function selectedAddon() {
      var checked = section.querySelector('input[name="anv-addon"]:checked');
      if (!checked || !checked.value) return null;
      return { id: checked.value, price: parseInt(checked.getAttribute('data-price'), 10) || 0, title: checked.getAttribute('data-title') || '' };
    }

    function currentBase() {
      if (variantSelect) {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        return parseInt(opt.getAttribute('data-price'), 10) || basePrice;
      }
      return basePrice;
    }

    function refresh() {
      var addon = selectedAddon();
      var wrap = selectedGift();
      var total = currentBase() + (addon ? addon.price : 0) + (wrap ? wrap.price : 0);
      if (submit && submitLabel && !submit.disabled) submit.textContent = submitLabel + ' · ' + formatMoney(total, currency);
      if (barPrice) barPrice.textContent = formatMoney(total, currency);
      if (barNote) {
        var extras = [];
        if (addon) extras.push(addon.title);
        if (wrap) extras.push('Gift wrap');
        barNote.textContent = extras.length ? '+ ' + extras.join(', ') : '';
      }
    }

    section.querySelectorAll('input[name="anv-addon"]').forEach(function (input) { input.addEventListener('change', refresh); });
    if (variantSelect) variantSelect.addEventListener('change', refresh);
    if (giftToggle) giftToggle.addEventListener('change', function () {
      syncGift();
      refresh();
      if (giftToggle.checked && giftMsg && !reduceMotion) giftMsg.focus({ preventScroll: true });
    });
    if (giftMsg) giftMsg.addEventListener('input', syncGift);
    syncGift();

    form.addEventListener('submit', function (event) {
      var addon = selectedAddon();
      var wrap = selectedGift();
      if (!window.fetch) return; // let the normal form post handle it
      event.preventDefault();
      var idField = form.querySelector('[name="id"]');
      var saree = { id: parseInt(idField.value, 10), quantity: 1 };
      if (wrap) {
        saree.properties = { 'Gift wrap': 'Yes' };
        if (wrap.message) saree.properties['Gift message'] = wrap.message;
      }
      var items = [saree];
      if (addon) items.push({ id: parseInt(addon.id, 10), quantity: 1 });
      if (wrap && wrap.id) {
        var titleEl = section.querySelector('.anv-pd__title');
        items.push({ id: wrap.id, quantity: 1, properties: { 'For': titleEl ? titleEl.textContent.trim() : '' } });
      }
      if (errorBox) errorBox.textContent = '';
      var buttons = section.querySelectorAll('[data-anv-submit], .anv-pd__bar .anv-btn');
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      var cartAdd = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
      fetch(cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data && (result.data.description || result.data.message) || 'Could not add to cart');
          window.location.href = form.getAttribute('data-cart-url') || '/cart';
        })
        .catch(function (err) {
          if (errorBox) errorBox.textContent = err.message;
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
        });
    });

    // Pinned bar on mobile: show it once the main button has scrolled out of view.
    if (bar && submit && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
        });
      });
      io.observe(submit);
    }

    refresh();
  }

  /* ---------- Six metres, laid out: unroll as it crosses the screen ---------- */
  var strips = [];
  var ticking = false;

  function updateStrip(stage) {
    var rect = stage.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // 0 when the strip's top enters at the bottom of the screen, 1 when it reaches the upper third
    var p = clamp((vh - rect.top) / (vh * 0.62), 0, 1);
    var eased = 1 - Math.pow(1 - p, 2);
    stage.style.setProperty('--p', eased.toFixed(4));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      strips.forEach(updateStrip);
    });
  }

  function setupStrips(scope) {
    (scope || document).querySelectorAll('[data-anv-unroll]').forEach(function (stage) {
      if (strips.indexOf(stage) === -1) strips.push(stage);
      if (reduceMotion || designMode) stage.style.setProperty('--p', '1');
      else updateStrip(stage);
    });
    strips = strips.filter(function (s) { return document.body.contains(s); });
  }

  function init(scope) {
    setHeaderOffset();
    (scope || document).querySelectorAll('[data-anv-gallery]').forEach(setupGallery);
    (scope || document).querySelectorAll('[data-anv-product]').forEach(setupBuyBox);
    setupStrips(scope);
  }

  if (!reduceMotion && !designMode) {
    // The theme scrolls inside .page-wrapper on desktop, so listen for scrolls on any element.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }
  window.addEventListener('resize', function () { setHeaderOffset(); onScroll(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
